<template>
    <main id="app" class="main" :class="{
        'is-ascending': navDirection > 0,
        'is-descending': navDirection < 0,
        ['is-' + backgroundColor]: true,
        'is-menu-open': $store.isMenuOpen
    }">
        <Background :color="backgroundColor" :page-num="pageNum"/>
        <Header/>
        <transition name="page" mode="out-in" :duration="{ enter: 1000, leave: 1000 }">
            <router-view/>
        </transition>
        <Footer/>
        <Nav/>
        <Menu/>
        <!-- <CookiesBanner/> -->
    </main>
</template>
<script>
import { router, routes } from '@/router'
import Resize from '@/mixins/Resize'
import Wheel from '@/mixins/Wheel'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import Nav from '@/components/Nav'
import Menu from '@/components/Menu'
// import CookiesBanner from '@/components/CookiesBanner'
import Background from '@/components/Background'
import store from '@/store'

const ROUTES_LIST = []
{
    const addRoute = route => route.children ? route.children.forEach(addRoute) : ROUTES_LIST.push(route)
    routes.forEach(addRoute)
}

/* eslint-disable */
const ADD_TRAKING = () =>
{
    // segment.com => Google Analytics + Hotjar
    !function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on"];analytics.factory=function(t){return function(){var e=Array.prototype.slice.call(arguments);e.unshift(t);analytics.push(e);return analytics}};for(var t=0;t<analytics.methods.length;t++){var e=analytics.methods[t];analytics[e]=analytics.factory(e)}analytics.load=function(t,e){var n=document.createElement("script");n.type="text/javascript";n.async=!0;n.src="https://cdn.segment.com/analytics.js/v1/"+t+"/analytics.min.js";var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(n,a);analytics._loadOptions=e};analytics.SNIPPET_VERSION="4.1.0";
    analytics.load("RYDnXbJqgRaGaLJpOuvhTpc4RRad583A");
    analytics.page();
    }}();

    // https://app.metomic.io/dashboard/developers
    !function(p,r,i,v,a,c,y){p.Metomic={apiKey:i};p[i]||(p[i]=function(){
    (p[i].q=p[i].q||[]).push(arguments)});p[i].l=+new Date;c=r.createElement(v);
    y=r.getElementsByTagName(v)[0];p.Metomic.script=c;c.src=a;y.parentNode.insertBefore(c,y)}(window,document,'prj:39cab6bd-e65c-41fd-a1de-b3e708b2cc12','script','https://consent-manager.metomic.io/embed.js');
}
/*eslint-enable */

export default {

    name: 'app',

    mixins: [
        Resize,
        Wheel
    ],

    components:
    {
        Header,
        Nav,
        Background,
        Menu,
        // CookiesBanner,
        Footer
    },

    data()
    {
        return {
            navDirection: 0,
            backgroundColor: 'light',
            pageNum: 0
        }
    },

    watch:
    {
        $route: 'onRouted'
    },

    created()
    {
        console.log('%cZeal agency', 'color: #0054ff; font-size: x-large; font-weight: bold;')
        console.log('%cWebsite by %cImmersive Garden', 'color: #a7a7ab;', 'color: #0054ff;')
        console.log('%cCreated with %c💙', 'color: #a7a7ab;', 'font-size: small;')
        console.log('%cFront framework %cVue.js', 'color: #a7a7ab;', 'color: #0054ff;')
        console.log('%cSSR %cPapillon', 'color: #a7a7ab;', 'color: #0054ff;')

        store.setRoutes(routes)
        this.onRouted(this.$route, this.$route)

        ADD_TRAKING()
    },

    methods:
    {
        onPrev()
        {
            if (!this.$route.meta.scroll)
            {
                const index = ROUTES_LIST.findIndex(route => route.name === this.$route.name)
                if (index > 0)
                {
                    router.push({
                        name: ROUTES_LIST[index - 1].name
                    })
                }
            }
        },

        onNext()
        {
            if (!this.$route.meta.scroll)
            {
                const index = ROUTES_LIST.findIndex(route => route.name === this.$route.name)
                if (index < ROUTES_LIST.length - 3)
                {
                    router.push({
                        name: ROUTES_LIST[index + 1].name
                    })
                }
            }
        },

        onResized(width, height)
        {
            // Fix phone
            const vh = height * 0.01
            window.document.documentElement.style.setProperty('--vh', `${vh}px`)
        },

        onRouted(to, from)
        {
            const fromIndex = ROUTES_LIST.findIndex(route => route.name === from.name)
            const toIndex = ROUTES_LIST.findIndex(route => route.name === to.name)

            this.navDirection = toIndex > fromIndex ? 1 : -1
            this.backgroundColor = to.meta.color
            this.pageNum++

            if (to.meta.scroll)
            {
                document.body.classList.add('is-scrollable')
            }
            else
            {
                document.body.classList.remove('is-scrollable')
            }

            store.setRoute(to)

            document.querySelector('head title')
                .innerHTML = to.meta.title || ''
            document.querySelector('meta[name=description]')
                .setAttribute('content', to.meta.description || '')
            document.querySelector('meta[name=robots]')
                .setAttribute('content', to.meta.robots || '')

            {
                const element = document.querySelector('link[rel=canonical]')
                if (element)
                {
                    element.parentElement.removeChild(element)
                }

                if (to.meta.canonical)
                {
                    const newElement = document.createElement('LINK')
                    newElement.setAttribute('rel', 'canonical')
                    newElement.setAttribute('href', to.meta.canonical)
                    document.querySelector('html>head').appendChild(newElement)
                }
            }

            setTimeout(this.papillon, 2000)
        },

        // SEO
        papillon()
        {
            const event = new CustomEvent('papillon')
            event.status = this.$route.name === '404' ? 404 : 200
            window.dispatchEvent(event)
        }
    }
}
</script>
<style lang="sass">
@import "./style/_settings/__index.sass"
@import "./style/_required/_index.sass"

main
    position: absolute
    width: 100%
    height: 100%
    display: flex
    flex-direction: column


$maxAnims: 10       // Number of blocks animated in one page
$maxAnimsLines: 5   // Number of blocks with lines animated
$maxLines: 15       // Number of lines animated in one block

.page-enter-active
    @for $i from 1 through $maxAnims

        .anim-#{ $i }
            transition: transform 0.7s cubic-bezier(.17, 0, .1, 1), opacity 0.7s cubic-bezier(.31,.01,.67,.99)
            transition-delay: (0.05s * $i), (0.05s * $i)
            will-change: opacity, transform

            .is-descending &
                transition-delay: (0.05s * ($maxAnims - $i)), (0.05s * ($maxAnims - $i))

.page-leave-active
    @for $i from 1 through $maxAnims

        .anim-#{ $i }
            transition: transform 0.7s cubic-bezier(.17, 0, .1, 1), opacity 0.7s cubic-bezier(.31,.01,.67,.99)
            transition-delay: (0.05s * ($maxAnims - $i)), (0.05s * ($maxAnims - $i))
            will-change: opacity, transform

            .is-descending &
                transition-delay: (0.05s * $i), (0.05s * $i)

.page-enter
    @for $i from 1 through $maxAnims

        .anim-#{ $i }
            opacity: 0
            transform: translateY(5vh)

            .is-descending &
                transform: translateY(-5vh)

.page-leave-to
    @for $i from 1 through $maxAnims

        .anim-#{ $i }
            opacity: 0
            transform: translateY(-5vh)

            .is-descending &
                transform: translateY(5vh)

.page-enter-active
    @for $i from 1 through $maxAnimsLines

        .anim-line-#{ $i }
            @for $j from 1 through $maxLines
                .word
                    transition: transform 0.7s cubic-bezier(.17, 0, .1, 1), opacity 0.7s cubic-bezier(.31,.01,.67,.99)
                    will-change: opacity, transform

                    &.line-#{ $j }
                        transition-delay: (0.05s * $j + 0.1s * $i), (0.05s * $j + 0.1s * $i)

                        .is-descending &
                            transition-delay: (0.05s * ($maxAnimsLines - $j) + 0.1s * ($maxAnimsLines - $i)), (0.05s * ($maxAnimsLines - $j) + 0.1s * ($maxAnimsLines - $i))

.page-leave-active
    @for $i from 1 through $maxAnimsLines

        .anim-line-#{ $i }
            @for $j from 1 through $maxLines

                .word
                    transition: transform 0.7s cubic-bezier(.17, 0, .1, 1), opacity 0.7s cubic-bezier(.31,.01,.67,.99)
                    will-change: opacity, transform

                    &.line-#{ $j }
                        transition-delay: (0.05s * ($maxAnimsLines - $j) + 0.1s * ($maxAnimsLines - $i)), (0.05s * ($maxAnimsLines - $j) + 0.1s * ($maxAnimsLines - $i))

                        .is-descending &
                            transition-delay: (0.05s * $j + 0.1s * $i), (0.05s * $j + 0.1s * $i)

@for $i from 1 through $maxAnimsLines

    .anim-enter.anim-line-#{ $i } // Fix
        @for $j from 1 through $maxLines

            .word.line-#{ $j }
                transition: none
                opacity: 0
                transform: translateY(5vh)

                .is-descending &
                    transform: translateY(-5vh)

.page-leave-to
    @for $i from 1 through $maxAnimsLines

        .anim-line-#{ $i }
            @for $j from 1 through $maxLines

                .word.line-#{ $j }
                    opacity: 0
                    transform: translateY(-5vh)

                    .is-descending &
                        transform: translateY(5vh)

</style>
